<script setup>
import { computed } from 'vue'

import AuditCard from './AuditCard.vue'
import AuditTurn from './AuditTurn.vue'
import { useAuditText } from './audit-text.js'
import { asArray } from './run-observer.js'

const props = defineProps({
  snapshot: { type: Object, required: true },
  pack: { type: Object, required: true },
  branch: { type: Object, required: true },
  // 当前分支的回合请求。
  requests: { type: Array, required: true },
})

const { tr } = useAuditText()
const turns = computed(() => asArray(props.branch.turns))
const opening = computed(() => (Array.isArray(props.pack.opening?.segments) ? props.pack.opening.segments : props.branch.opening ? [props.branch.opening] : []))
// 生成中的临时预览只在游玩进程内存里，后台详情拿不到，这里只标出有回合正在生成。
const generating = computed(() => props.requests.some((request) => request.status === 'generating'))
</script>

<template>
  <AuditCard :title="tr('story.title')" :hint="generating ? tr('story.generating') : ''" data-testid="observer-story">
    <template #meta>{{ tr('story.turnCount', { count: turns.length }) }}</template>
    <AuditTurn v-if="opening.length" :pack="pack" :label="tr('story.opening')" :segments="opening" />
    <AuditTurn
      v-for="turn in turns"
      :key="turn.turn_id || turn.seq"
      :pack="pack"
      :label="tr('turns.turn', { seq: turn.seq })"
      :segments="asArray(turn.segments)"
      :turn="turn"
      :request="snapshot.requests?.[turn.request_id] ?? null"
    />
    <p v-if="!opening.length && !turns.length" class="au-empty">{{ tr('empty') }}</p>
  </AuditCard>
</template>
